<!--
TELA DE FILTRO AVANÇADO DA BARRA DE LISTAS (BAR-LIST)

RECEBE UM OBJETO ARRAY COM OS FILTROS


-->

<template>

  <div class="nb-modal-mask" id="filtermodal">
    <div class="nb-modal nb-modal-60">
      <div class="nb-modal-inner">
        <label-title title="Pesquisa Avançada"></label-title><br>
        <div class="row">
          <div class="col-md-6 col-12" v-for="(filter, index) in lFilters" :key="index">
            <v-label :label="filter.filter.label"></v-label>
            <select2static v-model="campoteste" :options="filter.filter.options" :value="campoteste" :multiple="true"
              :minlength="0" parent="filtermodal">
            </select2static>
          </div>
        </div>

        <div class="row">
          <!-- FILTRO COM SELECAO DE OPCOES -->
          <!-- <div class="col-md-6 col-12" v-for="(filter, index) in lFilters" :key="index">
                        <div class="form-group">
                            <label class="lbl-edit">{{ filter.filter.label }}</label>
                            <div class="btn-group">
                                <a v-for="(option, index) in filter.filter.options" :key="index" href="javascript:void(0);" class="btn btn-sm"
                                :class="{'btn-success': option.selected, 'btn-outline-secondary': !option.selected}"
                                @click="selectButton(filter, option)"><i v-if="false" class="fa fa-check" aria-hidden="true"></i> {{ option.text }}</a>
                            </div>
                        </div>
                    </div> -->

        </div>
        <br>
        <div class="col">
          <v-button label="Aplicar" :nb-btdef="true" class="float-right" @click="handleApplyFilter"></v-button>
          <v-button label="Cancelar" class="float-right" @click="handleClose"></v-button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { SysVars } from '../main';

export default {
  props: {
    advFiltersObject: Array,
  },

  data() {
    return {
      lFilters: []
    }
  },

  methods: {
    selectButton(filter, option) {
      if (option.selected) {
        option.selected = false
      } else {
        option.selected = true
      }
    },

    handleApplyFilter(filters) {
      //envia o objeto local para o chamador
      this.lFilters = filters
      this.$emit('filter', this.lFilters)
    },

    handleClose() {
      this.$emit('close')
    },

  },

  created() {
    this.lFilters = this.advFiltersObject //recebe o parametro com os campos do filtro e joga para o objeto local
  }

}
</script>

<style >

</style>






// WEBPACK FOOTER //
// src/components/bar-filter.vue